import { CSSObject } from '@emotion/react'
import { AssetReference } from '@opallabs/cassini'
import { fonts, fontSizes, fontWeights } from '@opallabs/pulsar'
import getAssetOrientation from '../../helpers/functions/getAssetOrientation'
import { sharedColors } from '../sharedDisplays/sharedStyles/colors'

type DisplayProps = {
  [key: string]: {
    assetWidth: string
    width: number
  }
}

type AssetOverrideStylesProps = {
  asset: CSSObject
  assetBase: CSSObject
}

const renderLayout: DisplayProps = {
  desktopSingle: {
    assetWidth: '568px',
    width: 600,
  },
  mobileSingle: {
    assetWidth: '343px',
    width: 375,
  },
  desktopStream: {
    assetWidth: '509px',
    width: 600,
  },
  mobileStream: {
    assetWidth: '283px',
    width: 375,
  },
}

const baseStyles = (display: string, postType: string): CSSObject => ({
  backgroundColor: '#fff',
  border: postType === 'moment' ? sharedColors.momentBorder : 'none',
  borderRadius: 0,
  display: 'flex',
  flexDirection: 'column',
  width:
    postType === 'moment'
      ? `calc(${renderLayout[display].width}px - 2px)`
      : renderLayout[display].width,
})

const getAssetContainerStyles = (display: string): CSSObject => ({
  borderRadius: '10px',
  margin: display.includes('Stream')
    ? '0px 16px 2px 76px'
    : '0px 16px 2px 16px',
  overflow: 'hidden',
})

const getAssetStyles = (
  asset: AssetReference,
  display: string
): AssetOverrideStylesProps => {
  const orientation = getAssetOrientation(asset)
  const maxSize = renderLayout[display].assetWidth
  return {
    asset: {
      height: orientation === 'landscape' ? 'auto' : maxSize,
      maxWidth:
        orientation === 'portrait' && !display.includes('mobile')
          ? maxSize
          : '',
      width:
        orientation === 'portrait' && !display.includes('mobile')
          ? 'auto'
          : maxSize,
      gif: {
        height: orientation !== 'landscape' ? maxSize : '',
        marginBottom: '-1px',
        width: orientation !== 'portrait' ? maxSize : '',
      },
    },
    assetBase: {
      backgroundColor: 'black',
    },
  }
}

const gifLabelStyles: CSSObject = {
  alignItems: 'center',
  background: 'rgba(0,0,0,0.53)',
  borderRadius: '3px',
  color: 'white',
  display: 'flex',
  fontFamily: fonts.helvetica,
  fontSize: fontSizes.xSmall,
  fontWeight: fontWeights.boldest,
  height: '22px',
  justifyContent: 'center',
  margin: '-32px 0 0 10px',
  position: 'absolute',
  width: '32px',
}

const assetStyles = {
  baseStyles,
  getAssetContainerStyles,
  getAssetStyles,
  gifLabelStyles,
}

export { assetStyles }
